import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CsrfService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  private _token = signal<string | null>(null);
  token = this._token.asReadonly();

  get value(): string | null {
    return this._token();
  }

  fetchToken(): Observable<string> {
    return this.http
      .get<{ success: boolean; data: { csrfToken: string } }>(`${this.apiUrl}/auth/csrf`, {
        withCredentials: true,
      })
      .pipe(
        map((res) => res.data.csrfToken),
        tap((token) => this._token.set(token)),
      );
  }

  clear() {
    this._token.set(null);
  }
}
